import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/shirts.css";

const BestBuyAdmin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    brand: "",
    price: "",
    buyLink: "",
    rating: "",
    category: "Garments",
    platform: "",
    contributorName: "",
    contributorContact: "",
    payoutStatus: "Pending"
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Mock data for rewards table
  const [payouts, setPayouts] = useState([
    { id: 1, name: "Rahul S.", content: "The Boys", rating: 8.7, reward: 100, status: "Pending" },
    { id: 2, name: "Priya K.", content: "Stranger Things", rating: 9.1, reward: 50, status: "Pending" }
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!form.name.trim() || !form.buyLink.trim() || !form.rating.trim()) {
      setError("Please provide title/name, link, and rating.");
      return;
    }

    const ratingNum = parseFloat(form.rating);
    if (isNaN(ratingNum) || ratingNum < 0 || ratingNum > 10) {
      setError("Rating must be a number between 0 and 10.");
      return;
    }

    if (ratingNum < 7) {
      setError("Minimum rating required to post is 7.");
      return;
    }

    // OTT Deep Link Validation
    if (form.category === "OTT") {
      if (!form.platform.trim()) {
        setError("Please specify the platform for OTT content.");
        return;
      }
      const deepLinkPatterns = ["/title/", "/watch/", "/details/", "/play/"];
      const isDeepLink = deepLinkPatterns.some(pattern => form.buyLink.includes(pattern));
      if (!isDeepLink) {
        setError("Please provide a direct content URL (deep link) rather than a generic homepage link.");
        return;
      }
    }

    const rewardAmount = ratingNum >= 9 ? 100 : 50;

    const newItem = {
      id: Date.now(),
      name: form.name.trim(),
      brand: form.category === "OTT" ? form.platform.trim() : form.brand.trim() || "Unknown Brand",
      price: form.category === "OTT" ? "Subscription" : form.price.trim() || "Contact for price",
      buyLink: form.buyLink.trim(),
      rating: ratingNum,
      category: form.category,
      platform: form.platform.trim(),
      contributorName: form.contributorName.trim(),
      contributorContact: form.contributorContact.trim(),
      rewardAmount,
      payoutStatus: form.payoutStatus
    };

    console.log("New Product Added:", newItem);

    // Add to local payout table for visualization
    if (form.contributorName.trim()) {
        setPayouts(prev => [{
            id: Date.now(),
            name: form.contributorName.trim(),
            content: form.name.trim(),
            rating: ratingNum,
            reward: rewardAmount,
            status: "Pending"
        }, ...prev]);
    }

    setSuccess(`${form.category} recommendation added successfully! Reward of ₹${rewardAmount} tracked for ${form.contributorName || "Internal"}.`);
    setForm({
        name: "", brand: "", price: "", buyLink: "", rating: "",
        category: "Garments", platform: "", contributorName: "",
        contributorContact: "", payoutStatus: "Pending"
    });
  };

  return (
    <div className="admin-page" style={{ padding: "20px", maxWidth: "1000px", margin: "0 auto" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", marginBottom: "20px" }}>
        <h2 style={{ margin: 0 }}>BestBuy Admin: Post a Recommendation</h2>
        <button onClick={() => navigate("/bestBuy")} style={{ padding: "8px 12px", background: "#6c757d", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" }}>
          View Public Page
        </button>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "30px", alignItems: "start" }}>

        {/* Form Section */}
        <div style={{ background: "#fff", padding: "24px", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
            <form onSubmit={handleSubmit}>
            <h3 style={{ marginTop: 0 }}>Content & Contributor Details</h3>

            {error && <div style={{ color: "#b00020", marginBottom: "15px", padding: "10px", background: "#fdecea", borderRadius: "4px" }}>{error}</div>}
            {success && <div style={{ color: "#2e7d32", marginBottom: "15px", padding: "10px", background: "#edf7ed", borderRadius: "4px" }}>{success}</div>}

            <div style={{ marginBottom: "12px" }}>
                <label style={{ display: "block", fontSize: "14px", marginBottom: "4px" }}>Category</label>
                <select
                name="category"
                value={form.category}
                onChange={handleChange}
                style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ddd" }}
                >
                <option value="Garments">Garments</option>
                <option value="OTT">OTT (Movies/Series)</option>
                <option value="Watches">Watches</option>
                </select>
            </div>

            <div style={{ marginBottom: "12px" }}>
                <label style={{ display: "block", fontSize: "14px", marginBottom: "4px" }}>
                {form.category === "OTT" ? "Title (Movie/Series Name)" : "Product Name"}
                </label>
                <input
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder={form.category === "OTT" ? "e.g. Stranger Things" : "e.g. Slim Fit Cotton Shirt"}
                style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ddd" }}
                />
            </div>

            {form.category === "OTT" ? (
                <div style={{ marginBottom: "12px" }}>
                <label style={{ display: "block", fontSize: "14px", marginBottom: "4px" }}>Platform</label>
                <select
                    name="platform"
                    value={form.platform}
                    onChange={handleChange}
                    style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ddd" }}
                >
                    <option value="">Select Platform</option>
                    <option value="Netflix">Netflix</option>
                    <option value="Amazon Prime">Amazon Prime</option>
                    <option value="Disney+ Hotstar">Disney+ Hotstar</option>
                    <option value="JioCinema">JioCinema</option>
                    <option value="Other">Other</option>
                </select>
                </div>
            ) : (
                <div style={{ marginBottom: "12px" }}>
                <label style={{ display: "block", fontSize: "14px", marginBottom: "4px" }}>Brand</label>
                <input
                    name="brand"
                    value={form.brand}
                    onChange={handleChange}
                    placeholder="e.g. Brand X"
                    style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ddd" }}
                />
                </div>
            )}

            <div style={{ marginBottom: "12px" }}>
                <label style={{ display: "block", fontSize: "14px", marginBottom: "4px" }}>Rating (out of 10)</label>
                <input
                name="rating"
                type="number"
                step="0.1"
                value={form.rating}
                onChange={handleChange}
                placeholder="Min 7.0 required (7-8.9: ₹50, 9+: ₹100)"
                style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ddd" }}
                />
            </div>

            <div style={{ marginBottom: "12px" }}>
                <label style={{ display: "block", fontSize: "14px", marginBottom: "4px" }}>
                {form.category === "OTT" ? "Direct Content URL (Deep Link)" : "Buy Link"}
                </label>
                <input
                name="buyLink"
                value={form.buyLink}
                onChange={handleChange}
                placeholder={form.category === "OTT" ? "e.g. https://www.netflix.com/title/80057281" : "https://example.com/..."}
                style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ddd" }}
                />
            </div>

            <hr style={{ margin: "20px 0", border: "0", borderTop: "1px solid #eee" }} />
            <h4 style={{ marginTop: 0 }}>Contributor Tracking (Optional)</h4>

            <div style={{ marginBottom: "12px" }}>
                <label style={{ display: "block", fontSize: "14px", marginBottom: "4px" }}>Contributor Name</label>
                <input
                name="contributorName"
                value={form.contributorName}
                onChange={handleChange}
                placeholder="Name from Trust Support"
                style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ddd" }}
                />
            </div>

            <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", fontSize: "14px", marginBottom: "4px" }}>Contact (WhatsApp/Email)</label>
                <input
                name="contributorContact"
                value={form.contributorContact}
                onChange={handleChange}
                placeholder="For payment processing"
                style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ddd" }}
                />
            </div>

            <button type="submit" style={{ width: "100%", padding: "12px", background: "#0d6efd", color: "white", border: "none", borderRadius: "4px", cursor: "pointer", fontWeight: "600" }}>
                Post Recommendation
            </button>
            </form>
        </div>

        {/* Payouts Section */}
        <div style={{ background: "#fff", padding: "24px", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
            <h3 style={{ marginTop: 0 }}>Pending Payouts</h3>
            <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                    <thead>
                        <tr style={{ textAlign: "left", borderBottom: "2px solid #eee" }}>
                            <th style={{ padding: "10px" }}>Contributor</th>
                            <th style={{ padding: "10px" }}>Content</th>
                            <th style={{ padding: "10px" }}>Rating</th>
                            <th style={{ padding: "10px" }}>Reward</th>
                            <th style={{ padding: "10px" }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payouts.map(p => (
                            <tr key={p.id} style={{ borderBottom: "1px solid #eee" }}>
                                <td style={{ padding: "10px" }}>{p.name}</td>
                                <td style={{ padding: "10px" }}>{p.content}</td>
                                <td style={{ padding: "10px" }}>{p.rating}</td>
                                <td style={{ padding: "10px", fontWeight: "600", color: "#2e7d32" }}>₹{p.reward}</td>
                                <td style={{ padding: "10px" }}>
                                    <span style={{
                                        padding: "4px 8px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                        background: p.status === "Pending" ? "#fff3e0" : "#e8f5e9",
                                        color: p.status === "Pending" ? "#ef6c00" : "#2e7d32"
                                    }}>
                                        {p.status}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {payouts.length === 0 && (
                <div style={{ textAlign: "center", padding: "20px", color: "#999" }}>No pending payouts found.</div>
            )}
        </div>

      </div>
    </div>
  );
};

export default BestBuyAdmin;
